"use client";

import Image from "next/image";
import { storyblokEditable } from "@storyblok/react/rsc";
import { QuoteIcon } from "@/components/icons/QuoteIcon";
import { RichTextField } from "@/components/typography/RichTextField";

type TestimonialCardStoryblok = {
  text?: string;
  name?: string;
  description?: string;
  image?: { filename?: string; alt?: string };
  _uid: string;
  component: "testimonial_card";
  [k: string]: any;
};

type TestimonialCardProps = {
  blok: TestimonialCardStoryblok;
  fullWidth?: boolean;
};

const TestimonialCard = ({ blok, fullWidth }: TestimonialCardProps) => {
  return (
    <div
      className={`flex flex-col justify-between bg-white rounded-2xl px-4 py-6 h-full ${fullWidth ? "w-full" : "w-[280px] md:w-[320px]"}`}
      {...storyblokEditable(blok)}
    >
      {/* Quote text */}
      <div className="flex flex-col md:flex-row gap-3 items-start">
        <QuoteIcon className="shrink-0 w-6 h-6" />
        <RichTextField value={blok.text} className="text-copy text-black leading-[1.2] min-w-0" />
      </div>

      {/* Person info - pushed to bottom */}
      <div className="flex flex-col gap-3 mt-6">
        {blok.image?.filename && (
          <Image
            src={blok.image.filename}
            alt={blok.image.alt || blok.name || ""}
            width={48}
            height={48}
            className="w-12 h-12 rounded-full object-cover"
          />
        )}
        <div className="text-sm md:text-base text-black leading-[1.2] md:leading-snug">
          {blok.name && <p className="font-bold">{blok.name}</p>}
          {blok.description && <p>{blok.description}</p>}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
